import script from "./SidePanelSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SidePanelSection.vue?vue&type=script&setup=true&lang=js"

import "./SidePanelSection.vue?vue&type=style&index=0&id=a07c0084&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a07c0084"]])

export default __exports__